const styles = {
  searchingText: {
    width: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  notifyText: {
    wordBreak: "break-all",
  },
  skeletonContainer: {
    width: { xs: "95vw", md: "auto" },
  },
  excludedContainer: {
    p: 4,
    px: { xs: 2, lg: 20 },
    textAlign: "center",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: 300,
    mx: "auto",
    mt: 8,
    mb: 4,
    gap: 1.5,
  },
  emptyStateIcon: {
    fontSize: 26,
    color: "text.disabled",
  },
  emptyStateText: {
    fontSize: 14,
    color: "text.secondary",
    lineHeight: 1.5,
  },
};

export default styles;
